/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsContainerV1: {
  name: 'container-v1';
  data: string;
} = {
  name: 'container-v1',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 16v2h3v-2H4Zm3-2H4V8h3v8Zm2 1v3h2V4H9v13Zm11-9v8h-3V8h3Zm0 10h-3v2h3v-2Zm-5-1v3h-2V4h2v13ZM7 6H4V4h3v2Zm13-2v2h-3V4h3Z" fill="currentColor"/></svg>`,
};
